document.addEventListener('alpha.loaded', (e) => {
  const moduleMgr = e.detail.emitter
  const config = moduleMgr.getConfig()
  const btnAlphaPhoneEl = document.querySelector('.btn-alpha-phone')
  if (btnAlphaPhoneEl) {
    moduleMgr.addModuleEventListener('viewport', 'changed', (evt) => {
      if (evt.emitter.getViewport().is(`>=${config.desktopBreakpoint}`)) {
        btnAlphaPhoneEl.removeAttribute('data-bs-toggle')
      } else {
        btnAlphaPhoneEl.setAttribute('data-bs-toggle', 'dropdown')
      }
    })
  }
})
